// export const apiUrl = "http://localhost:9000/api/v1/portfolio";
export const apiUrl = process.env.REACT_APP_PORTFOLIO_API;
// export const apiUrl = "http://192.168.137.1:9000/api/v1/portfolio";

// export const apiUrl = "http://10.234.43.179/api/v1/portfolio";
// "https://portfoliobackend-tpdr.onrender.com/api/v1/portfolio";
// "https://portfoliobackend-tpdr.onrender.com/api/v1/portfolio" /* online api */
// export const apiUrl = `http://192.168.1.40:9000/api/v1/portfolio`;
// export const apiUrl = `https://portfoliobackend-tpdr.onrender.com/api/v1/portfolio`;
// export const apiUrl = `https://portfoliobackend-tpdr.onrender.com/api/v1/portfolio`;
